import { render, staticRenderFns } from "./voucherCreateCrm.vue?vue&type=template&id=54df812b&"
import script from "./voucherCreateCrm.vue?vue&type=script&lang=js&"
export * from "./voucherCreateCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports